import { render, staticRenderFns } from "./workplan_panel.vue?vue&type=template&id=38fa2e3a"
import script from "./workplan_panel.vue?vue&type=script&lang=js"
export * from "./workplan_panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports